import NumberFormat from 'react-number-format';
import {getSupportedLocale} from './locale';

export interface NumberFormatCustomProps {
  inputRef: (instance: NumberFormat<unknown> | null) => void;
  onChange: (event: {target: {name: string; value: string}}) => void;
  name: string;
}

export const getThousandsSeparator = () => {
  const locale = getSupportedLocale();
  switch (locale) {
    case 'en-CA': // Canada
    case 'en-GB': // Great Britain
    case 'gd': // Scotland
    case 'en-AU': // Australia
    case 'is': // Iceland
    case 'fo': // Faroe islands
      return ',';

    case 'es-CL': // Chile
      return '.';

    case 'no': // Norway
    default:
      return ' ';
  }
};

export const getDecimalSeparator = () => {
  const locale = getSupportedLocale();
  switch (locale) {
    case 'en-GB': // Great Britain
    case 'gd': // Scotland
    case 'en-AU': // Australia
    case 'is': // Iceland
    case 'fo': // Faroe islands
      return '.';

    case 'es-CL': // Chile
    case 'en-CA': // Canada
    case 'no': // Norway
    default:
      return ',';
  }
};

/**
 *
 * @deprecated
 */
export default function NumberFormatCustom(props: NumberFormatCustomProps) {
  const {inputRef, onChange, ...other} = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator={getThousandsSeparator()}
      isNumericString
      decimalSeparator={getDecimalSeparator()}
    />
  );
}
